module.exports = __webpack_public_path__ + "img/guide_vs1_1.5bde4af3.png";